module.exports = __webpack_public_path__ + "static/media/joel-spolsky_200x200.e257d571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/joel-spolsky_200x200.jpg
// module id = 268
// module chunks = 0